import { render } from "./UserListDialog.vue?vue&type=template&id=47250e28&scoped=true"
import script from "./UserListDialog.vue?vue&type=script&lang=js"
export * from "./UserListDialog.vue?vue&type=script&lang=js"

import "./UserListDialog.vue?vue&type=style&index=0&id=47250e28&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47250e28"]])

export default __exports__